import 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-mouse-position';
import './leaflet-plug/leaflet.ChineseTmsProviders';
import "./leaflet-plug/Leaflet.Canvas-Markers-master/src/_full.js";
import 'leaflet.vectorgrid';
import 'leaflet-boundary-canvas';
import './leaflet-plug/leafletHeader'
// import 'maplibre-gl/dist/maplibre-gl';
// import 'maplibre-gl/dist/maplibre-gl.css';
// import './leaflet-plug/leaflet-maplibre-gl/leaflet-maplibre-gl';
// import './leaflet-plug/leaflet-geotiff-master/leaflet-geotiff';
import 'georaster'; // tif
import './leaflet-plug/leaflet-side-by-side-gh-pages/leaflet-side-by-side';


// draw默认配置
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";

L.drawLocal = {
  draw: {
    toolbar: {
      // #TODO: this should be reorganized where actions are nested in actions
      // ex: actions.undo  or actions.cancel
      actions: {
        title: '取消绘图',//'Cancel drawing',
        text: '取消'//'Cancel'
      },
      finish: {
        title: '完成绘图',//'Finish drawing',
        text: '完成'
      },
      undo: {
        title: '删除最后绘制的点',//'Delete last point drawn',
        text: '撤销'//'Delete last point'
      },
      buttons: {
        polyline: '绘制一个多段线',//'Draw a polyline',
        polygon: '绘制一个多边形',//'Draw a polygon',
        rectangle: '绘制一个矩形',//'Draw a rectangle',
        circle: '绘制一个圆',//'Draw a circle',
        marker: '绘制一个标记',//'Draw a marker',
        circlemarker: '绘制一个圆形标记'//'Draw a circlemarker'
      }
    },
    handlers: {
      circle: {
        tooltip: {
          start: '单击并拖动以绘制圆'//'Click and drag to draw circle.'
        },
        radius: 'Radius'
      },
      circlemarker: {
        tooltip: {
          start: '单击“地图”以放置圆标记'//'Click map to place circle marker.'
        }
      },
      marker: {
        tooltip: {
          start: '单击“地图”以放置标记'//'Click map to place marker.'
        }
      },
      polygon: {
        tooltip: {
          start: '单击开始绘制形状',//'Click to start drawing shape.',
          cont: '单击继续绘制形状',//'Click to continue drawing shape.',
          end: '单击第一个点关闭此形状'//'Click first point to close this shape.'
        }
      },
      polyline: {
        error: '<strong>错误:</strong>形状边缘不能交叉！',//'<strong>Error:</strong> shape edges cannot cross!',
        tooltip: {
          start: '单击开始绘制线',//'Click to start drawing line.',
          cont: '单击以继续绘制线',//'Click to continue drawing line.',
          end: '单击“最后一点”以结束线'//'Click last point to finish line.'
        }
      },
      rectangle: {
        tooltip: {
          start: '单击并拖动以绘制矩形'//'Click and drag to draw rectangle.'
        }
      },
      simpleshape: {
        tooltip: {
          end: '释放鼠标完成绘图'//'Release mouse to finish drawing.'
        }
      }
    }
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: '保存更改',//'Save changes',
          text: '保存'//'Save'
        },
        cancel: {
          title: '取消编辑，放弃所有更改',//'Cancel editing, discards all changes',
          text: '取消'//'Cancel'
        },
        clearAll: {
          title: '清除所有图层',//'Clear all layers',
          text: '清除所有'//'Clear All'
        }
      },
      buttons: {
        edit: '编辑图层',//'Edit layers',
        editDisabled: '无可编辑的图层',//'No layers to edit',
        remove: '删除图层',//'Delete layers',
        removeDisabled: '无可删除的图层'//'No layers to delete'
      }
    },
    handlers: {
      edit: {
        tooltip: {
          text: '拖动控制柄或标记以编辑要素',//'Drag handles or markers to edit features.',
          subtext: '单击“取消”撤消更改'//'Click cancel to undo changes.'
        }
      },
      remove: {
        tooltip: {
          text: '单击要删除的要素'//'Click on a feature to remove.'
        }
      }
    }
  }
};
import store from '@/store';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("@/assets/leaflet/marker-icon.png"),
  iconUrl: require("@/assets/leaflet/marker-icon.png"),

  shadowUrl: null,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -14],
});
// 处理Popup销毁后zoom渲染问题
const Popup_animateZoom = L.Popup.prototype._animateZoom;
L.Popup.prototype._animateZoom = function (e) {
  if (!this._map) {
    return;
  }
  if (!this._map._latLngToNewLayerPoint) {
    return;
  }
  Popup_animateZoom.call(this, e);
};
const Tooltip_animateZoom = L.Tooltip.prototype._animateZoom;
L.Tooltip.prototype._animateZoom = function (e) {
  // console.log(e);
  if (!this._map) {
    return;
  }
  if (!this._map._latLngToNewLayerPoint) {
    return;
  }
  Tooltip_animateZoom.call(this, e);
};
const Tooltip_updatePosition = L.Tooltip.prototype._updatePosition;
L.Tooltip.prototype._updatePosition = function () {
  if (!this._map) {
    return;
  }
  if (!this._map._latLngToNewLayerPoint) {
    return;
  }
  Tooltip_updatePosition.call(this);
}
// 处理Marker销毁后zoom渲染问题
const Marker_animateZoom = L.Marker.prototype._animateZoom;
L.Marker.prototype._animateZoom = function (opt) {
  if (!this._map) {
    return;
  }
  if (!this._map._latLngToNewLayerPoint) {
    return;
  }
  Marker_animateZoom.call(this, opt);
};
const ImageOverlay_animateZoom = L.ImageOverlay.prototype._animateZoom;
L.ImageOverlay.prototype._animateZoom = function (e) {
  if (!this._map) {
    return;
  }
  if (!this._map._latLngToNewLayerPoint) {
    return;
  }
  ImageOverlay_animateZoom.call(this, e);
}
const GridLayer_updateLevels = L.GridLayer.prototype._updateLevels;
L.GridLayer.prototype._updateLevels = function (e) {
  if (!this._map) {
    return;
  }
  GridLayer_updateLevels.call(this, e);
}

const ImageOverlay_initialize = L.ImageOverlay.prototype.initialize;
L.ImageOverlay.prototype.initialize = function (url, bounds, options) {
  options = options || {};
  return ImageOverlay_initialize.call(this, url, bounds, {
    ...options,
    pane: 'shadowPane',
  });
}




// 基于重新 onEachFeature 方法的样式处理
export const jsonStyleInit = (geojson, config) => {
  let properties;
  if (geojson['properties']) {
    properties = geojson['properties'];
  } else {
    properties = {};
    geojson['properties'] = properties;
  }
  properties['fill'] = config['fill'] || properties['fill'];
  properties['dashArray'] = config['dashArray'] || properties['dashArray'];
  properties['weight'] = config['weight'] || properties['weight'];
}

const geojsonLayerColorSet = (feature, layer) => {
  const polygonStyle = store.getters['leafletPolygon/polygonStyle']
  layer.setStyle && layer.setStyle({
    color: (feature['properties'] && feature['properties']['fill']) || polygonStyle['color'],
    dashArray: (feature['properties'] && feature['properties']['dashArray']) || '0',
    weight: (feature['properties'] && feature['properties']['weight']) || 2,
  })
}
const geojson_initialize = L.GeoJSON.prototype.initialize;
L.GeoJSON.prototype.initialize = function (geojson, options) {
  // console.log(this, geojson, options);
  options = options || {};
  const onEachFeature = options['onEachFeature'];
  if (onEachFeature) {
    options['onEachFeature'] = function (feature, layer) {
      geojsonLayerColorSet(feature, layer);
      onEachFeature.call(this, feature, layer);
    }
  } else {
    options['onEachFeature'] = function (feature, layer) {
      geojsonLayerColorSet(feature, layer);
    }
  }
  return geojson_initialize.call(this, geojson, options);
}

const setTransform = L.DomUtil.setTransform;
L.DomUtil.setPosition = function (el, point, scale) {
  el._leaflet_pos = point;
  if (L.Browser.any3d) {
    setTransform(el, point, scale);
  } else {
    el.style.left = point.x + 'px';
    el.style.top = point.y + 'px';
  }
}
const domUtil_setPosition = L.DomUtil.setPosition;
L.Marker.prototype._setPos = function (pos) {
  const zoom = this.options['defaultZoom'],
    map = this._map, changeZoom = map && map.getZoom(),
    scale = (zoom && map && changeZoom) && Math.pow(1.5, changeZoom - zoom);
  if (this._icon) {
    domUtil_setPosition(this._icon, pos, scale);
  }
  if (this._shadow) {
    domUtil_setPosition(this._shadow, pos);
  }
  this._zIndex = pos.y + this.options.zIndexOffset;
  this._resetZIndex();
}

/**
 * ========================================================
 * 全局扩展：解决跨图层组的多边形遮挡问题 (极致性能优化版)
 * ========================================================
 */
L.Map.include({
  organizePolygonsByArea: function () {
    // 1、防止在批量发接口（或组件频次更新）中被疯狂调用，做动画帧级别的请求合并
    if (this._organizeZIndexFrame) {
      cancelAnimationFrame(this._organizeZIndexFrame);
    }

    this._organizeZIndexFrame = requestAnimationFrame(() => {
      const allPolygons = [];

      // 2、全量捕获多边形
      this.eachLayer(function (layer) {
        if (layer instanceof L.Polygon) {
          allPolygons.push(layer);
        }
      });

      if (allPolygons.length <= 1) return;

      // 3、施瓦茨变换 (O(N) 复杂度一次性计算面积，告别在 Sort 中疯狂计算)
      const mappedArr = allPolygons.map(layer => {
        let area = 0;
        // 【核心优化】：结果缓存。只要这个多边形的 id 不变，面积只算一遍
        if (layer._computedArea != null) {
          area = layer._computedArea;
        } else if (layer.getBounds) {
          const bounds = layer.getBounds();
          if (bounds && bounds.isValid()) {
             // 此处通过外接矩形测算极快，避免复杂的几何算法
            area = (bounds.getNorth() - bounds.getSouth()) * (bounds.getEast() - bounds.getWest());
            layer._computedArea = area; 
          }
        }
        return { layer, area };
      });

      // 4、纯属字类型高速排序 O(N log N) —— (降序：大到小)
      mappedArr.sort((a, b) => b.area - a.area);

      // 5、重排 DOM。
      // 因为没有去读取任何 `offsetHeight` 这类的触发重绘(Reflow)的变数，
      // 所以连续的 bringToFront (底层是 appendChild) 同样会被浏览器合并为 1 次批量 Layout 控制！
      mappedArr.forEach(item => {
        if (item.layer.bringToFront) {
          item.layer.bringToFront();
        }
      });
    });

    return this; 
  }
});